/**
 * Open and close the header
 */

const navToggle = ($) => {
	$("#nav-toggle").on("click", function () {
		const header = $("#header");
		const body = $("body");

		if (header.hasClass("js-open-menu")) {
			header.removeClass("js-open-menu");
			body.toggleClass("menu-open");
		} else {
			header.addClass("js-open-menu");
			body.toggleClass("menu-open");
		}
	});
};

export default navToggle;
